(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["libero-card-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('libero-card-layout')) {
    customElements.define('libero-card-layout', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.wrapper = this.previousElementSibling;
        if (!this.wrapper?.matches('.product-card-wrapper')) return;
        this.wrapper.classList.add('libero-card-layout');
        const inner = this.wrapper.querySelector('.card__inner');
        if (!inner) return;
        this.badge = document.createElement('span');
        this.badge.className = 'libero-card-discount';
        this.badge.hidden = true;
        inner.append(this.badge);
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.wrapper, {childList: true, subtree: true, characterData: true});
        this.sync();
        this.timers = [100, 500, 1500, 4000].map(delay => setTimeout(() => this.sync(), delay));
        customElements.whenDefined('dmixer-sale-badge').then(() => {
          if (this.isConnected) this.schedule();
        });
      }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }
      sync() {
        if (!this.isConnected || !this.badge) return;
        const source = this.wrapper.querySelector('.card-information dmixer-sale-badge');
        const root = source?.shadowRoot;
        if (root !== this.sourceRoot) {
          this.shadowObserver?.disconnect();
          this.sourceRoot = root;
          if (root) {
            this.shadowObserver = new MutationObserver(() => this.schedule());
            this.shadowObserver.observe(root, {childList: true, subtree: true, characterData: true});
          }
        }
        const sourceText = (root?.querySelector('[part="text"]')?.textContent || source?.textContent || '').trim();
        const match = sourceText.match(/(\d+(?:[.,]\d+)?)\s*%/);
        let label = this.dataset.nativeLabel || '';
        let hasAppDiscount = false;
        if (match && this.dataset.available === 'true') {
          const percent = Number(match[1].replace(',', '.'));
          if (percent > 0 && percent <= 100) {
            const template = /up\s*to/i.test(sourceText) ? this.dataset.upToLabel : this.dataset.percentLabel;
            label = template.replace('[percent]', String(percent));
            hasAppDiscount = true;
          }
        }
        if (this.badge.textContent !== label) this.badge.textContent = label;
        this.badge.hidden = !label;
        this.wrapper.classList.toggle('libero-has-discount', Boolean(label));
        this.wrapper.classList.toggle('libero-has-app-discount', hasAppDiscount);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.shadowObserver?.disconnect();
        this.timers?.forEach(clearTimeout);
        this.badge?.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
